import React from 'react'
import { NavLink, Redirect, Route, Switch } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { AppRoutes } from '~/AppRoutes'
import { Stats } from '~/components/admin/Stats'
import { RecentUsers } from '~/components/admin/RecentUsers'
import { UserView } from '~/components/admin/UserView'
import { RecentProjects } from '~/components/admin/RecentProjects'
import { RecentMediaFiles } from '~/components/admin/RecentMediaFiles'
import { MediaFileErrors } from '~/components/admin/MediaFileErrors'
import { RecentRenderErrors } from '~/components/admin/RecentRenderErrors'
import './AdminPanel.scss'

const tabs = [
  { text: 'Stats', url: AppRoutes.AdminStats },
  { text: 'Recent users', url: AppRoutes.AdminRecentUsers },
  { text: 'Recent projects', url: AppRoutes.AdminRecentProjects },
  { text: 'Recent media files', url: AppRoutes.AdminRecentMediaFiles },
  { text: 'Media file errors', url: AppRoutes.AdminMediaFileErrors },
  { text: 'Render errors', url: AppRoutes.AdminRenderErrors },
]

export const AdminPanel = () => {
  const isAdmin = useSelector(state => state.user.admin)

  if (!isAdmin) {
    return <div className="admin-panel__access-denied">Access denied</div>
  }

  return (
    <div className="admin-panel">
      <div className="admin-panel__tabs">
        {tabs.map(tab => (
          <NavLink
            key={tab.url}
            to={tab.url}
            className="admin-panel__tabs__tab"
            activeClassName="admin-panel__tabs__tab--active"
          >
            {tab.text}
          </NavLink>
        ))}
      </div>
      <div className="admin-panel__content">
        <Switch>
          <Route exact path={AppRoutes.AdminStats}>
            <Stats />
          </Route>
          <Route exact path={AppRoutes.AdminRecentUsers}>
            <RecentUsers />
          </Route>
          <Route exact path={AppRoutes.AdminUser}>
            <UserView />
          </Route>
          <Route exact path={AppRoutes.AdminRecentProjects}>
            <RecentProjects />
          </Route>
          <Route exact path={AppRoutes.AdminRecentMediaFiles}>
            <RecentMediaFiles />
          </Route>
          <Route exact path={AppRoutes.AdminMediaFileErrors}>
            <MediaFileErrors />
          </Route>
          <Route exact path={AppRoutes.AdminRenderErrors}>
            <RecentRenderErrors />
          </Route>
          <Route exact path={AppRoutes.AdminPanel}>
            <Redirect to={AppRoutes.AdminStats} />
          </Route>
        </Switch>
      </div>
    </div>
  )
}
